import { render, staticRenderFns } from "./AddTreatment.vue?vue&type=template&id=029e49cf&scoped=true"
import script from "./AddTreatment.vue?vue&type=script&lang=js"
export * from "./AddTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e49cf",
  null
  
)

export default component.exports